import React from 'react';
import { getCtaUrl } from '../../../utils';
import Button from '../Button/Button';

import './index.scss';

const Section = ({ title, link = null, bgColor, extraClassNames = '', children }) => {
  return (
    <section className={`egp-section ${bgColor}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="title">
              <h2>{title}</h2>

              {link && (
                <div className="section-cta">
                  <Button
                    url={getCtaUrl(link.link)}
                    label={link.link?.label ? link.link.label : link.link.content.label}
                    customVariant={'light'}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className={`main-content row ${extraClassNames}`}>
          {children}

          {link && (
            <div className={'mobile-cta'}>
              <Button
                url={getCtaUrl(link.link)}
                label={link.link?.label ? link.link.label : link.link.content.label}
                customVariant={'light'}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Section;
